export const createConfetti = () => {
  const container = document.createElement('div');
  container.className = 'confetti-container';
  document.body.appendChild(container);

  const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff'];

  for (let i = 0; i < 20; i++) {
    const confetti = document.createElement('div');
    confetti.className = 'confetti';
    confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
    confetti.style.left = Math.random() * 100 + '%';
    confetti.style.animationDelay = Math.random() * 0.5 + 's';
    confetti.style.animationDuration = (Math.random() * 3 + 2) + 's';
    container.appendChild(confetti);

    setTimeout(() => confetti.remove(), 5000);
  }

  setTimeout(() => container.remove(), 6000);
};

export const createMassiveConfetti = () => {
  const container = document.createElement('div');
  container.className = 'confetti-container';
  document.body.appendChild(container);

  const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ffa500'];

  for (let i = 0; i < 50; i++) {
    setTimeout(() => {
      const confetti = document.createElement('div');
      confetti.className = 'confetti';
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.left = Math.random() * 100 + '%';
      confetti.style.animationDelay = Math.random() * 0.5 + 's';
      confetti.style.animationDuration = (Math.random() * 3 + 2) + 's';

      const size = Math.random() * 15 + 10;
      confetti.style.width = size + 'px';
      confetti.style.height = size + 'px';

      container.appendChild(confetti);

      setTimeout(() => confetti.remove(), 5000);
    }, Math.random() * 1000);
  }

  setTimeout(() => container.remove(), 6000);

  // Add shake effect
  document.body.classList.add('shake-crazy');
  setTimeout(() => {
    document.body.classList.remove('shake-crazy');
  }, 1000);
};